module.exports = __webpack_public_path__ + "img/blog.fb5a3ccb.jpg";